<template>
  <img class="bg" id="background-image" src="../assets/papers/paper.jpg" alt="">
    <div class="home">
      <div v-for="(image, index) in images" :key="index" class="images-background">
        <img
        v-if="index < visibleImages"
          :src="image.src"
          :style="{
            position: 'fixed',
            top: image.top + '%',
            left: image.left + '%',
            width: image.width + 'px',
            ...(image.style || {}),
          }"
          :class="image.class"
        />
      </div>

      <canvas id="canvas-drawing"></canvas> 
      <div id="threejs-canvas"></div>
      <div ref="p5container"></div>

    </div>
  </template>

  <script>
  //import p5 from 'p5';
  import { displayCollage } from '@/services/DisplayCollage';
  import { initThree } from '@/services/HomePage3D';
  import { sketch } from '@/services/HomePageSketch';
  //import { spiral } from '@/services/DisplaySpiral';

  export default {
    name: 'HomePage',
    data() {
      return {
        images: [
          { src: '/HomePage/chambre_pastel.jpg' },
          { src: '/HomePage/collage_pour_peinture.jpg' },
          { src: '/HomePage/star5.png' },
          { src: '/HomePage/couverture_coquillages.jpg' },
          { src: '/HomePage/coverartober_2024_20.jpg' },
          { src: '/HomePage/PICT0081.jpg' },
          { src: '/HomePage/bug.jpg' },
          { src: '/HomePage/star4.png' },
          { src: '/HomePage/page.jpg' },
          { src: '/HomePage/peinture_meduses.jpg' },
          { src: '/HomePage/coverartober_2024_12.jpg' },
          { src: '/HomePage/PICT0139.jpg' },
          { src: '/HomePage/triangle.png' },
          { src: '/HomePage/wild_screen_1.jpg' },
          { src: '/HomePage/room5_1.png' },
          { src: '/HomePage/star3.png' },
          { src: '/HomePage/photo.jpg' },
          { src: '/HomePage/pietro.png' },
          { src: '/HomePage/result.png' },
          { src: '/HomePage/star2.png' },
          { src: '/HomePage/line1.jpg' },
          { src: '/HomePage/robe_bijoux.png' },
          { src: '/HomePage/result5.png' },
          { src: '/HomePage/star1.png' },
          { src: '/HomePage/chateau.png' },
          // { src: '/HomePage/tulipes.png' },
          { src: '/HomePage/star.png' },
          
        ],
        visibleImages: 0,
      };
    },
    mounted() {
      
      displayCollage(this.images);
      const totalDuration = 2000; 
      const intervalTime = totalDuration / this.images.length;

      const intervalId = setInterval(() => {
        if (this.visibleImages < this.images.length) {
          this.visibleImages += 1;
        } else {
          clearInterval(intervalId); 
        }
      }, intervalTime);

      initThree('threejs-canvas');

      sketch();

      // spiral();

      //this.myP5 = new p5(spiral, this.$refs.p5container);
      
    },
    beforeUnmount() {
      if (this.myP5) {
        this.myP5.remove();
      }
    },
    methods: {

    }
  }
</script>

  
  <style scoped>
  .home {
    text-align: center;
    padding: 20px;
  }
  
  #background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover; 
    object-position: center; 
    z-index: -20;
    opacity: 30%;
  }

  #threejs-canvas {
    position: fixed;
    top: 0; 
    left: 0;
    z-index: -5;
    pointer-events: none;
}


  /* .collage-image {
    transition: all 1s ease-in-out;
  } */

  .images-background img{
    z-index: -10;
  }

  #canvas-drawing {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -15;
    pointer-events: none; 
  }

  /* pour le responsive */

  /* html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
} */

  </style>
  